import ROUTES from "../../../config/Routes";

export const createDossierFromTp = (
  accountId,
  thirdparty,
  history,
  location
) => {
  history.push(`/${accountId}/${ROUTES.TP_ADD_DOSSIER.replace(':thirdpartyId', thirdparty.thirdpartyId)}`, {
    prevPath: location.pathname,
  });
};

export const navigationItems = [
  // {
  //   name: "owlin.label",
  //   icon: "./thirdparty/stickyMenu/owlin",
  //   sectionId: "owlin",
  // },
  // {
  //   name: "ESG.label",
  //   icon: "./thirdparty/stickyMenu/esg",
  //   sectionId: "esg"
  // },
  // {
  //   name: "ecovadis.EVratings",
  //   icon: "./thirdparty/stickyMenu/ecovadis",
  //   sectionId: "ecovadis"
  // },
  {
    name: "thirdpartySheet.items.attributes",
    icon: "./thirdparty/stickyMenu/attributes",
    sectionId: "attributes"
  },
  {
    name: "thirdpartySheet.items.indicators",
    icon: "./thirdparty/stickyMenu/indicators",
    sectionId: "indicators"
  },
  {
    name: "thirdpartySheet.items.risk",
    icon: "./thirdparty/stickyMenu/risk",
    sectionId: "risk"
  },
  {
    name: "thirdpartySheet.items.datahub",
    icon: "./thirdparty/stickyMenu/datahub",
    sectionId: "datahub"
  },
  {
    name: "thirdpartySheet.items.contextes",
    icon: "./thirdparty/stickyMenu/contexte",
    sectionId: "contextes"
  },
  {
    name: "thirdpartySheet.items.dossiers",
    icon: "./thirdparty/stickyMenu/dossier",
    sectionId: "dossiers"
  },
  {
    name: "thirdpartySheet.items.documents",
    icon: "./thirdparty/stickyMenu/document",
    sectionId: "documents"
  },
  {
    name: "thirdpartySheet.items.contacts",
    icon: "./thirdparty/stickyMenu/contact",
    sectionId: "contacts"
  },
  {
    name: "thirdpartySheet.items.notes",
    icon: "./thirdparty/stickyMenu/note",
    sectionId: "notes"
  },
  {
    name: "thirdpartySheet.items.archives",
    icon: "./thirdparty/stickyMenu/dossier",
    sectionId: "archives"
  },
];
